import { useEffect, useState } from "react";

/**
 * Trails a value by `delay`, so typing in the search box does not fire a
 * request per keystroke. The input stays controlled by the immediate value —
 * only the fetch waits.
 *
 * A timer is an external system, which is the one thing an effect is for.
 *
 * @param {*} value
 * @param {number} [delay]
 */
export function useDebouncedValue(value, delay = 350) {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return settled;
}
